import {
    FAILED_TO_GET_SOLICITOR_IMAGES, GET_SOLICITOR_IMAGES, INCREMENT_IMAGE_COUNTER, LOGOUT, RECEIVE_IMAGE_FILE,
    RECEIVE_SOLICITOR_IMAGES
} from "../actions/index";

const defaultState = {
    fetching: false,
    images: [],
    fileImages: [],
    imageCounter: 0,
    fetchedImageIndexes: [],
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case INCREMENT_IMAGE_COUNTER:
            let indexes = [...state.fetchedImageIndexes];
            let c = state.imageCounter;
            if(!indexes.includes(action.payload)){
                indexes.push(action.payload);
                c = c + 1;
            }
            return {
                ...state,
                imageCounter: c,
                fetchedImageIndexes: indexes
            };
        case RECEIVE_IMAGE_FILE:
            // if(action.payload.status === 200){
            //     let fileImgs = [...state.fileImages];
            //     fileImgs.push(btoa(unescape(encodeURIComponent(action.payload.text))))
            //     return {
            //         ...state,
            //         fileImages: fileImgs
            //     };
            // }
            return {
                ...state
            };
        case GET_SOLICITOR_IMAGES:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_SOLICITOR_IMAGES:
            return {
                ...state,
                fetching: false,
                images: action.payload
            };
        case FAILED_TO_GET_SOLICITOR_IMAGES:
            return {
                ...state,
                fetching: false,
                images: []
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        default:
            return state
    }
}